var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_506_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 269.902C305.608 269.902 345.967 229.543 345.967 179.935C345.967 130.327 305.608 89.9673 256 89.9673C206.392 89.9673 166.032 130.327 166.032 179.935C166.032 229.543 206.392 269.902 256 269.902ZM256 119.956C289.072 119.956 315.978 146.863 315.978 179.935C315.978 213.007 289.072 239.913 256 239.913C222.928 239.913 196.021 213.007 196.021 179.935C196.021 146.863 222.928 119.956 256 119.956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.352 280.315C425.371 250.596 435.934 215.971 435.934 179.935C435.934 80.7188 355.216 0 255.999 0C156.783 0 76.0645 80.7188 76.0645 179.935C76.0645 215.971 86.6276 250.596 106.646 280.315L255.999 512L405.352 280.315ZM255.999 29.9892C338.68 29.9892 405.945 97.2549 405.945 179.935C405.945 208.303 398.073 235.604 383.151 259.404C383.099 259.486 266.198 440.83 255.999 456.651C243.475 437.222 147.289 288.014 128.847 259.404C113.926 235.604 106.054 208.304 106.054 179.935C106.054 97.2549 173.319 29.9892 255.999 29.9892V29.9892Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_506_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.da1d773fc138d800f8ad757c06382f54.svg";
export { ForwardRef as ReactComponent };